import { render, staticRenderFns } from "./List.vue?vue&type=template&id=3af1d3c1"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af1d3c1')) {
      api.createRecord('3af1d3c1', component.options)
    } else {
      api.reload('3af1d3c1', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=3af1d3c1", function () {
      api.rerender('3af1d3c1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Users/UsersRoles/List.vue"
export default component.exports